import React, { useRef, useState, useEffect } from "react";
import styles from "./quantitySelector.scss";
import { PropTypes } from "prop-types";
import NewSpinner from "../newSpinner/newSpinner";

function QuantitySelector({
  isOutOfStock,
  onQuantityChange,
  quantity,
  disableAddToCart,
  minQuantityRule,
  isLoading,
  //maxQuantityRule
}) {
  const [cursor, setCursor] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    const input = ref.current;
    if (input) input.setSelectionRange(cursor, cursor);
  }, [ref, cursor, quantity]);

  const incQuantity = () => {
    if (isOutOfStock || disableAddToCart) return;
    if (quantity > 98) return onQuantityChange(99);
    onQuantityChange(quantity + 1);
  };

  const decQuantity = () => {
    if (isOutOfStock || disableAddToCart) return;
    if (quantity <= minQuantityRule) return;
    onQuantityChange(quantity - 1);
  };

  const firstMethod = (e) => {
    if (isOutOfStock || disableAddToCart) return;
    const re = /[0-9A-F:]+/g;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleBlur = (e) => {
    if (isOutOfStock || disableAddToCart) return;
    let val = e.target.value;
    if (val > 99) return onQuantityChange(99);

    if (val === "" || Number(val) === 0) {
      onQuantityChange(minQuantityRule);
    }
  };

  const handleChange = (e) => {
    if (isOutOfStock || disableAddToCart) return;
    setCursor(e.target.selectionStart);
    if (e.target.value < minQuantityRule || e.target.value > 99)
      return onQuantityChange(null);
    onQuantityChange(Number(e.target.value));
  };

  return (
    <div className={styles["quantitySelector-cont"]}>
      <div
        className={styles["quantity-btn-div"]}
        style={
          isOutOfStock || disableAddToCart ? { borderColor: "#949494" } : null
        }
      >
        <svg
          width="10"
          height="4"
          viewBox="0 0 10 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={decQuantity}
        >
          <path
            d="M9.28571 0.928589H0.714286C0.319866 0.928589 0 1.24845 0 1.64287V2.35716C0 2.75158 0.319866 3.07145 0.714286 3.07145H9.28571C9.68013 3.07145 10 2.75158 10 2.35716V1.64287C10 1.24845 9.68013 0.928589 9.28571 0.928589Z"
            fill={isOutOfStock || disableAddToCart ? "#949494" : "#2C2C2C"}
          />
        </svg>

        <div className={styles["input-wrapper"]}>
          {isLoading ? (
            <NewSpinner />
          ) : (
            <input
              type="tel"
              style={
                isOutOfStock || disableAddToCart ? { color: "#949494" } : null
              }
              onBlur={handleBlur}
              value={quantity === "" ? minQuantityRule : quantity}
              className={styles["quantity-input-tag"]}
              maxLength="2"
              minLength="1"
              onChange={handleChange}
              onKeyPress={firstMethod}
              onPaste={(event) => {
                event.preventDefault()
              }}
            />
          )}
        </div>
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={incQuantity}
        >
          <path
            d="M9.28571 3.92857H6.07143V0.714286C6.07143 0.319866 5.75156 0 5.35714 0H4.64286C4.24844 0 3.92857 0.319866 3.92857 0.714286V3.92857H0.714286C0.319866 3.92857 0 4.24844 0 4.64286V5.35714C0 5.75156 0.319866 6.07143 0.714286 6.07143H3.92857V9.28571C3.92857 9.68013 4.24844 10 4.64286 10H5.35714C5.75156 10 6.07143 9.68013 6.07143 9.28571V6.07143H9.28571C9.68013 6.07143 10 5.75156 10 5.35714V4.64286C10 4.24844 9.68013 3.92857 9.28571 3.92857Z"
            fill={isOutOfStock || disableAddToCart ? "#949494" : "#2C2C2C"}
          />
        </svg>
      </div>
    </div>
  );
}

QuantitySelector.defaultProps = {
  isOutOfStock: false,
  quantity: 1,
  minQuantityRule: 1,
};
QuantitySelector.propTypes = {
  isOutOfStock: PropTypes.bool,
};

export default QuantitySelector;
